import React, { useState, useEffect } from "react";
import { Button, Container } from "react-bootstrap";
import FileAuditUploadService from "../../../services/fileAuditUpload.service";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";

interface DownloadTemplateProps {
  questionId: number;
  buttonText?: string;
}

function DownloadTemplate({
  questionId,
  buttonText = "Descargar Plantilla",
}: DownloadTemplateProps) {
  const [downloadUrl, setDownloadUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchDownloadUrl = async () => {
      setLoading(true);
      setError("");
      setDownloadUrl(null); // Reset previous URL

      try {
        const files = await FileAuditUploadService.getFilesQuestion(questionId);
        if (files && files.length > 0) {
          // Suponemos que solo hay un archivo de plantilla o que quieres el primero
          const firstFile = files[0];
          setDownloadUrl(firstFile.shareableUrl);
        } else {
          setError("No se encontró la plantilla para descargar.");
        }
      } catch (err) {
        setError("Error al obtener la URL de descarga.");
        console.error("Error fetching download URL:", err);
      } finally {
        setLoading(false);
      }
    };

    if (questionId) {
      fetchDownloadUrl();
    } else {
      setLoading(false);
      setError("ID de pregunta no proporcionado.");
    }
  }, [questionId]);

  if (loading) {
    return <div className="text-center">Cargando enlace de descarga...</div>;
  }

  if (error) {
    return <div className="text-center text-danger">{error}</div>;
  }

  return (
    <Container className="text-center">
      {downloadUrl ? (
        <Button
          variant="primary"
          href={downloadUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon icon={faDownload} className="me-2" />
          {buttonText}
        </Button>
      ) : (
        <p className="text-muted">
          No hay plantilla disponible para descargar.
        </p>
      )}
    </Container>
  );
}

export default DownloadTemplate;
